{
    "nBCnb": {
        "position": {
            "x": 16,
            "y": 14,
            "z": 1
        },
        "templateKey": "jobs/monster/slime/water",
        "jobKey": "monster/slime/water",
        "key": "nBCnb",
        "previousMultiselect": [
            "xAxl5",
            "xAxl5",
            "ECIPH",
            "ECIPH",
            "kActi",
            "kActi",
            "BxhFB",
            "BxhFB",
            "KcBpw",
            "KcBpw",
            "QX4y7",
            "QX4y7",
            "d4iuE",
            "d4iuE",
            "tbW_V",
            "tbW_V",
            "nBCnb",
            "nBCnb",
            "teT7v",
            "teT7v"
        ]
    },
    "jM_0A": {
        "position": {
            "x": 13,
            "y": 8,
            "z": 1
        },
        "templateKey": "jobs/monster/skeleton",
        "jobKey": "monster/skeleton",
        "key": "jM_0A",
        "previousMultiselect": [
            "jM_0A",
            "jM_0A",
            "jM_0A"
        ]
    },
    "K2hMW": {
        "position": {
            "x": 12,
            "y": 12,
            "z": 1
        },
        "templateKey": "jobs/monster/slime/earth",
        "jobKey": "monster/slime/earth",
        "key": "K2hMW",
        "previousMultiselect": [
            "yKxso",
            "yKxso",
            "X7fnF",
            "X7fnF",
            "Oyj-J",
            "Oyj-J"
        ]
    },
    "C7WmF": {
        "position": {
            "x": 15,
            "y": 10,
            "z": 1
        },
        "templateKey": "jobs/monster/skeleton",
        "jobKey": "monster/skeleton",
        "key": "C7WmF",
        "previousMultiselect": [
            "jM_0A",
            "jM_0A",
            "jM_0A"
        ]
    },
    "Wa5WZ": {
        "position": {
            "x": 16,
            "y": 7,
            "z": 1
        },
        "templateKey": "jobs/monster/goblin",
        "jobKey": "monster/goblin",
        "key": "Wa5WZ",
        "previousMultiselect": [
            "zWhZ6",
            "zWhZ6"
        ],
        "maxhealth": "30"
    },
    "C9-Mi": {
        "position": {
            "x": 19,
            "y": 14,
            "z": 1
        },
        "templateKey": "jobs/monster/slime/queen",
        "jobKey": "monster/slime/queen",
        "key": "C9-Mi",
        "previousMultiselect": [
            "C9-Mi",
            "C9-Mi"
        ]
    },
    "ji4Hz": {
        "position": {
            "x": 11,
            "y": 9,
            "z": 1
        },
        "templateKey": "jobs/monster/slime/fire",
        "jobKey": "monster/slime/fire",
        "key": "ji4Hz",
        "previousMultiselect": [
            "xAxl5",
            "xAxl5",
            "ECIPH",
            "ECIPH",
            "kActi",
            "kActi",
            "BxhFB",
            "BxhFB",
            "KcBpw",
            "KcBpw",
            "QX4y7",
            "QX4y7",
            "d4iuE",
            "d4iuE",
            "tbW_V",
            "tbW_V",
            "nBCnb",
            "nBCnb",
            "teT7v",
            "teT7v"
        ]
    },
    "f-I-r": {
        "position": {
            "x": 8,
            "y": 9,
            "z": 1
        },
        "templateKey": "jobs/monster/slime/fire",
        "jobKey": "monster/slime/fire",
        "key": "f-I-r",
        "previousMultiselect": [
            "f-I-r"
        ]
    },
    "iyGAI": {
        "position": {
            "x": 14,
            "y": 12,
            "z": 1
        },
        "templateKey": "jobs/monster/slime/earth",
        "jobKey": "monster/slime/fire",
        "key": "iyGAI",
        "previousMultiselect": [
            "yKxso",
            "yKxso",
            "X7fnF",
            "X7fnF",
            "Oyj-J",
            "Oyj-J"
        ]
    },
    "XRyIH": {
        "position": {
            "x": 14,
            "y": 14,
            "z": 1
        },
        "templateKey": "jobs/monster/slime/earth",
        "jobKey": "monster/slime/fire",
        "key": "XRyIH",
        "previousMultiselect": [
            "yKxso",
            "yKxso",
            "X7fnF",
            "X7fnF",
            "Oyj-J",
            "Oyj-J"
        ]
    },
    "81Kn6": {
        "position": {
            "x": 9,
            "y": 10,
            "z": 1
        },
        "templateKey": "jobs/monster/slime/earth",
        "jobKey": "monster/slime/earth",
        "key": "81Kn6",
        "previousMultiselect": [
            "yKxso",
            "yKxso",
            "X7fnF",
            "X7fnF",
            "Oyj-J",
            "Oyj-J"
        ]
    },
    "Da8Ck": {
        "position": {
            "x": 11,
            "y": 10,
            "z": 1
        },
        "templateKey": "jobs/monster/slime/water",
        "jobKey": "monster/slime/water",
        "key": "Da8Ck",
        "previousMultiselect": [
            "xAxl5",
            "xAxl5",
            "ECIPH",
            "ECIPH",
            "kActi",
            "kActi",
            "BxhFB",
            "BxhFB",
            "KcBpw",
            "KcBpw",
            "QX4y7",
            "QX4y7",
            "d4iuE",
            "d4iuE",
            "tbW_V",
            "tbW_V",
            "nBCnb",
            "nBCnb",
            "teT7v",
            "teT7v"
        ],
        "maxhealth": "50"
    },
    "w-TjF": {
        "position": {
            "x": 7,
            "y": 14,
            "z": 1
        },
        "templateKey": "jobs/monster/skeleton",
        "jobKey": "monster/skeleton",
        "key": "w-TjF",
        "previousMultiselect": [
            "jM_0A",
            "jM_0A",
            "jM_0A"
        ]
    },
    "ExkM0": {
        "position": {
            "x": 9,
            "y": 12,
            "z": 1
        },
        "templateKey": "jobs/monster/skeleton",
        "jobKey": "monster/skeleton",
        "key": "ExkM0",
        "previousMultiselect": [
            "jM_0A",
            "jM_0A",
            "jM_0A"
        ]
    },
    "frog": {
        "position": {
            "x": 12,
            "y": 14,
            "z": 1
        },
        "templateKey": "player/dice/frog",
        "key": "frog",
        "previousMultiselect": [
            "frog",
            "frog"
        ]
    },
    "x6s-C": {
        "position": {
            "x": 18,
            "y": 12,
            "z": 1
        },
        "templateKey": "jobs/monster/slime/water",
        "jobKey": "monster/slime/water",
        "key": "x6s-C",
        "previousMultiselect": [
            "xAxl5",
            "xAxl5",
            "ECIPH",
            "ECIPH",
            "kActi",
            "kActi",
            "BxhFB",
            "BxhFB",
            "KcBpw",
            "KcBpw",
            "QX4y7",
            "QX4y7",
            "d4iuE",
            "d4iuE",
            "tbW_V",
            "tbW_V",
            "nBCnb",
            "nBCnb",
            "teT7v",
            "teT7v"
        ]
    }
}